<template>
  <v-card color="primary" class="card">
    <v-card-text>
      <v-container>
        <v-row>
          <v-col cols="12">
            <v-text-field
              :value="cursoPersonal.ProgramacionCurso.Subcategoria.subcategoria"
              rounded
              readonly
              filled
              dense
              background-color="primary"
              color="secondary"
              label="Curso realizado"
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <div class="text-subtitle-2 font-weight-bold">Categoría</div>
            <div class="text-subtitle-2">
              {{ cursoPersonal.ProgramacionCurso.Subcategoria.CatCategoria.categoria }}
            </div>
          </v-col>
          <v-col cols="12">
            <div class="text-subtitle-2 font-weight-bold">Tipo</div>
            <div class="text-subtitle-2">
              {{ cursoPersonal.ProgramacionCurso.Subcategoria.CatCategoria.CatTipoCurso.title }}
            </div>
          </v-col>
          <v-col cols="6">
            <div class="text-subtitle-2 font-weight-bold">Asistió</div>
            <v-icon v-if="cursoPersonal.asistencia == 1" color="success">mdi-check</v-icon>
            <v-icon v-else color="error">mdi-close-circle</v-icon>
          </v-col>
          <v-col cols="6">
            <div class="text-subtitle-2 font-weight-bold">Calificación</div>
            <div class="text-subtitle-2" v-if="cursoPersonal.calificacion.length > 0">
              {{ cursoPersonal.calificacion }}
            </div>
            <div class="text-subtitle-2" v-else>No asignada</div>
          </v-col>
          <v-col cols="12">
            <div class="text-subtitle-2 font-weight-bold">Comentarios</div>
            <div class="text-subtitle-2" v-if="cursoPersonal.comentario.length > 0">
              {{ cursoPersonal.comentario }}
            </div>
            <div class="text-subtitle-2" v-else>Ninguno</div>
          </v-col>
          <v-col cols="12" align="right">
            <v-text-field
              :value="calificacionEvaluacion"
              @input="updateCalificacionEvaluador($event)"
              :rules="[(v) => (v >= 0 && v <= 10) || 'La calificación debe estar entre 0 y 10']"
              label="Calificación a evaluador"
              type="number"
              min="0"
              max="10"
              rounded
              filled
              dense
              background-color="primary"
              color="secondary"
            />
            <TextButton :loading="loading" :disabled="loading" @click="updateEvaluacion">Guardar</TextButton>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'
import TextButton from '../base/TextButton.vue'

export default {
  components: {
    TextButton,
  },

  props: {
    cursoPersonal: {
      type: Object,
      required: true,
    },
  },

  mounted() {
    this.calificacionEvaluacion = this.cursoPersonal.calificacionEvaluacion ?? 0
  },

  data() {
    return {
      calificacionEvaluacion: 0,
      loading: false,
    }
  },

  methods: {
    ...mapActions('cursoAsignado', ['updateAsignacionCursosPersonal']),
    ...mapMutations(['SET_SNACKBAR_MESSAGE']),

    updateCalificacionEvaluador(value) {
      const parsedValue = Number(value)

      if (parsedValue > 0 && parsedValue <= 10) {
        this.calificacionEvaluacion = parsedValue
      }
    },

    async updateEvaluacion() {
      try {
        this.loading = true
        const payload = {
          ...this.cursoPersonal,
          calificacionEvaluacion: String(this.calificacionEvaluacion),
        }
        await this.updateAsignacionCursosPersonal([payload])
        this.SET_SNACKBAR_MESSAGE('Calificación asignada correctamente')
      } catch {
        this.SET_SNACKBAR_MESSAGE('Error al asignar la calificación')
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
